import React from 'react';
import Rollbar from 'rollbar';
import rollbarConfig from '../config/rollbar.config';
import posthog from 'posthog-js';

/**
 * Error Boundary component that catches React errors and reports to Rollbar
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    
    // Initialize Rollbar
    this.rollbar = new Rollbar(rollbarConfig);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console for development
    console.error('Error caught by ErrorBoundary:', error, errorInfo);

    // Send error to Rollbar
    this.rollbar.error(error, {
      componentStack: errorInfo.componentStack
    });

    // Send exception to PostHog
    posthog.captureException(error, { extra: { componentStack: errorInfo.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1>Oops! Something went wrong</h1>
          <p>We're sorry for the inconvenience. Our team has been notified.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
